import React, { useEffect, useState} from 'react';
import "./alice.css"
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";

import { testimonials } from "../data/index";

const handleOnDragStart = e => e.preventDefault();

const AliceCaru = ({ media_type, id }) => {
 
      
     
    const items = testimonials?.map((c) => (
        <div className="cardiz"  >
            <h2 className='quote' >{c.quote}</h2>
            <div className='manname' >
               <img src={c.img} alt='alta' className='dpoz' />
                <div className='rightProf' >
                    <h2 className='dpName' >{c.name}</h2>
                    <p className='dpTitile' >{c.title}</p>
                </div>
            </div>
            
        </div>
    ))

    const responsive = {
        0 : {
            items : 1,
        },

        512 : {
            items: 1,
        },

        812 : {
          items: 2,
        },

        1024 : {
            items: 3,
        },
    }

  

  
  return (
    <AliceCarousel
                  autoPlay
                  
                  autoPlayInterval={4000}
                  responsive={responsive} 
                  mouseDragEnabled 
                  mouseTracking
                  infinite
                  disableDotsControls
                  disableButtonsControls
                  animationEasingFunction='ease'
                  items={items} />

    
  )
}

export default AliceCaru 